import { useHistory, generatePath } from 'react-router';
import { useCallback } from 'react';

export const useNavigation = () => {
  const history = useHistory();
  const push = useCallback((route, params) => {
    history.push({
      pathname: generatePath(route.compiledPath, params),
      // search: window.location.search,
    });
  }, [history]);

  const replace = useCallback((route, params) => {
    history.replace({
      pathname: generatePath(route.compiledPath, params),
      // search: window.location.search,
    });
  }, [history]);

  return {
    push,
    replace,
  };
};
